import cx from "classnames";
import React from "react";
import LinkedInIcon from "./LinkedInIcon";
import Section from "../Section";
import UserContext from "../../utils/context";

const Footer: React.FC = (): React.ReactElement => {
  const value = React.useContext(UserContext);

  return (
    <Section className="u-background-color-secondary" id="Footer">
      <div
        className={cx([
          "u-flex",
          "u-flex-column",
          "u-margin-top-negative-0point875rem",
          "u-margin-bottom-negative-0point875rem",
        ])}
      >
        <div
          className={cx([
            "u-flex",
            "u-justify-content-center",
            "u-padding-bottom-0point875rem",
            "u-padding-top-0point875rem",
            "u-width-fullWidth",
          ])}
        >
          <div
            className={cx([
              "u-padding-left-0point875rem",
              "u-padding-right-0point875rem",
              "u-width-full",
            ])}
          >
            <div
              className={cx([
                "u-align-items-center",
                "u-flex",
                "u-flex-column",
                "u-margin-bottom-0point875rem",
              ])}
            >
              <a
                className={cx([
                  "u-color-link",
                  "u-margin-bottom-0",
                  "u-margin-top-0",
                  "u-padding-top-4xs",
                  "u-text-no-underline",
                ])}
                href="mailto:mooreje518@gmail.com"
              >
                {value.email}
              </a>
            </div>
            <div
              className={cx([
                "u-flex",
                "u-flex-row",
                "u-justify-content-center",
                "u-padding-bottom-4xs",
                "u-padding-top-2xs",
              ])}
            >
              <a
                className={cx([
                  "julia-website-footer-logos",
                  "u-margin-left-0point875rem",
                  "u-padding-top-4xs",
                ])}
                href="https://www.linkedin.com/in/juliamoore518"
              >
                <LinkedInIcon fill="rgb(35, 72, 94)" height={42} />
              </a>
            </div>
            <hr
              className={cx([
                "u-border-color-primary",
                "u-horizontal-rule",
                "u-margin-top-2xs",
              ])}
            />
            <p
              className={cx([
                "julia-website-footer-copyright",
                "u-color-copyright",
                "u-font-size-2xs",
                "u-line-height-m",
                "u-margin-bottom-0",
                "u-margin-top-0",
                "u-text-center",
              ])}
            >
              Copyright &copy;&nbsp;
              {value.name}
              &nbsp;{new Date().getFullYear()}
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default React.memo(Footer);
